import type { UseMutationOptions } from '@tanstack/react-query'

interface RouteContext {
  url: string
}

interface OperationContext {
  operationId: string
  operationName: string
}

// "createUser" -> "Create user"
const humanizeOperationName = (operationName: string): string => {
  const withSpaces = operationName
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .trim()

  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1)
}

// Orval mutationOptions mutator: every generated mutation carries a
// mutationKey (generated by orval) plus the meta title/description required
// by the Aktivitäten interaction tracking (see src/state/client). The
// defaults derive from the operation; call sites providing their own meta
// (e.g. proper German copy) always win.
export const mutationOptionsWithInteraction = <
  TData = unknown,
  TError = unknown,
  TVariables = unknown,
  TContext = unknown,
>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
  { url }: RouteContext,
  { operationName }: OperationContext,
): UseMutationOptions<TData, TError, TVariables, TContext> => {
  return {
    ...options,
    meta: {
      title: humanizeOperationName(operationName),
      description: url,
      ...options.meta,
    },
  }
}

export default mutationOptionsWithInteraction
